/**
 * VALIDATION ERROR MESSAGES
 *
 * View here for a list of Vee-Validate's translations if you're adding a new language.
 *
 * @link https://github.com/logaretm/vee-validate/tree/master/locale
 */
export default {
    // ENGLISH
    en: {
        messages: {
            acMaxPeople: 'No more than {max} people',
            acMinPeople: 'No less than {min} people',
            alpha: 'Can only contain alphabetic characters',
            'alpha_num': 'Can only contain alphanumeric characters',
            alphaNumSpaces: 'Can only contain alphanumeric characters and spaces',
            'alpha_dash': 'Can contain alphanumeric characters, dashes, and underscores',
            'alpha_spaces': 'Can only contain alphabetic characters and spaces',
            between: 'Number must be between {min} and {max}',
            confirmed: '{target} fields do not match',
            deliveryDate: 'Combination not possible. Please select new date',
            digits: 'Must be numeric and contain exactly {length} digits',
            dimensions: 'Must be {width} pixels by {height} pixels',
            email: 'Email address is not valid',
            emailTld: 'Email address domain is not valid',
            excluded: 'Not an acceptable value',
            ext: 'Not an acceptable file type',
            googleAddressPostalCode: 'A postal code or city is required',
            googleAddressStreetNumber: 'An address with a street number is required',
            image: 'The file type must be an image',
            integer: 'Must be an integer',
            is: 'Does not match the expected value',
            'is_not': 'Cannot be "{value}"',
            length: 'Must be {length} characters long',
            max: 'Must be no more than {length} characters',
            'max_value': 'Must be {max} or less',
            mimes: 'The file type is invalid',
            min: 'Must be at least {length} characters',
            'min_value': 'Must be {min} or more',
            numeric: 'Can only contain numeric characters',
            oneOf: 'Not an accepted value',
            regex: 'Format is invalid',
            required: 'This field is required',
            'required_if': 'This field is required',
            size: 'The file must be less than {size}KB',
        }
    },


    // GERMAN
    de: {
        messages: {
            acMaxPeople: 'Maximal {max} Personen',
            acMinPeople: 'Minimum {min} Personen',
            alpha: 'Darf nur alphabetische Zeichen beinhalten',
            'alpha_num': 'Darf nur alphanumerische Zeichen beinhalten',
            alphaNumSpaces: 'Darf nur alphanumerische Zeichen und Leerzeichen beinhalten',
            'alpha_dash': 'Kann alphanumerische Zeichen, Bindestriche und Unterstriche beinhalten',
            'alpha_spaces': 'Darf nur alphabetische Zeichen oder Leerzeichen beinhalten',
            between: 'Zahl muss zwischen {min} und {max} sein',
            confirmed: '{target} Felder stimmen nicht überein',
            deliveryDate: 'Auswahl nicht möglich. Bitte neues Datum auswählen',
            digits: 'Muss numerisch sein und genau {length} Zeichen beinhalten',
            dimensions: 'Muss die Größe {width} x {height} pixel haben',
            email: 'E-Mail Adresse ist nicht gültig',
            emailTld: 'Domain der E-Mail Adresse ist nicht gültig',
            excluded: 'Kein akzeptierter Wert',
            ext: 'Kein akzeptierter Dateityp',
            googleAddressPostalCode: 'Eine Postleitzahl oder ein Ort ist erforderlich',
            googleAddressStreetNumber: 'Eine Adresse inkl. Hausnummer ist erforderlich',
            image: 'Der Dateityp muss ein Bild sein',
            integer: 'Muss eine ganze Zahl sein',
            is: 'Entspricht nicht dem erwarteten Wert',
            'is_not': 'Kann nicht "{value}" sein',
            length: 'Muss {length} Zeichen lang sein',
            max: 'Darf nicht länger als {length} Zeichen sein',
            'max_value': 'Darf nur {max} oder weniger Zeichen sein',
            mimes: 'Der Dateityp ist ungültig',
            min: 'Muss minimum {length} Zeichen sein',
            'min_value': 'Muss {min} oder mehr Zeichen sein',
            numeric: 'Darf nur numerische Zahlen beinhalten',
            oneOf: 'Kein akzeptierter Wert',
            regex: 'Format ist ungültig',
            required: 'Feld ist ein Pflichtfeld',
            'required_if': 'Feld ist ein Pflichtfeld',
            size: 'Die Datei muss kleiner sein als {size} KB',
        }
    },


    // DUTCH
    nl: {
        messages: {
            acMaxPeople: 'Maximaal {max} personen',
            acMinPeople: 'Minimaal {min} personen',
            alpha: 'Mag alleen alfabetische tekens bevatten',
            'alpha_num': 'Mag alleen alfanumerieke tekens bevatten',
            alphaNumSpaces: 'Mag alleen alfanumerieke tekens en spaties bevatten',
            'alpha_dash': 'Kan alfanumerieke tekens, streepjes en onderstrepingstekens bevatten',
            'alpha_spaces': 'Mag alleen alfabetische tekens en spaties bevatten',
            between: 'Getal moet tussen {min} en {max} liggen',
            confirmed: '{target} -velden komen niet overeen',
            deliveryDate: 'Combinatie niet mogelijk. Kies een nieuwe datum',
            digits: 'Moet numeriek zijn en exact {lengte} cijfers bevatten',
            dimensions: 'Moet {width} pixels bij {height} pixels zijn',
            email: 'E-mailadres is niet geldig',
            emailTld: 'E-mailadresdomein is niet geldig',
            excluded: 'Geen acceptabele waarde',
            ext: 'Geen acceptabel bestandstype',
            googleAddressPostalCode: 'Een postcode of stad is vereist',
            googleAddressStreetNumber: 'Een adres met een huisnummer is vereist',
            image: 'Het bestandstype moet een afbeelding zijn',
            integer: 'Moet een geheel getal zijn',
            is: 'Komt niet overeen met de verwachte waarde',
            'is_not': 'Mag niet "{value}" zijn',
            length: 'Moet {length} tekens lang zijn',
            max: 'Mag niet meer dan {length} tekens bevatten',
            'max_value': 'Moet {max} of minder zijn',
            mimes: 'Het bestandstype is ongeldig',
            min: 'Moet minimaal {length} tekens bevatten',
            'min_value': 'Moet {min} of meer zijn',
            numeric: 'Mag alleen numerieke tekens bevatten',
            oneOf: 'Geen geaccepteerde waarde',
            regex: 'Formaat is ongeldig',
            required: 'Dit veld is verplicht',
            'required_if': 'Dit veld is verplicht',
            size: 'Het bestand moet kleiner zijn dan {size} KB',
        }
    },
};